<template>
  <div class="hr-projects">
    <PageHeader :title="pageTitle">
      <template #action>
        <v-btn
          v-if="isSuperHR"
          :to="{ name: 'hr-project-create' }"
          link
          color="blue"
          class="hr-projects__btn"
        >
          CREATE PROJECT
        </v-btn>
      </template>
    </PageHeader>

    <div class="hr-projects__list">
      <template v-if="isProjectsListNotEmpty">
        <ProjectCard
          v-for="project in projectsList"
          :key="project.id"
          :projectData="project"
        />

        <v-pagination
          v-if="pagination.pageCount > 1"
          v-model="paginationPage"
          class="mb-4"
          color="blue"
          :disabled="isDataLoading"
          :length="pagination.pageCount"
        ></v-pagination>
      </template>

      <template v-else>
        <div class="hr-projects__empty">
          <NoData
            title="The project list is empty"
            description="At the moment the bench has no project"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import PageHeader from '@/components/PageHeader.vue';
import NoData from '@/components/NoData.vue';
import ProjectCard from '@/components/HrProjects/Index/ProjectCard.vue';

export default {
  metaInfo: {
    title: 'Projects',
  },

  components: {
    PageHeader,
    NoData,
    ProjectCard,
  },

  data() {
    return {
      pageTitle: 'Projects',
    };
  },

  computed: {
    ...mapState('hrProjects', [
      'projectsList',
      'pagination',
      'isDataLoading',
    ]),

    ...mapGetters('auth', [
      'isSuperHR',
    ]),

    isProjectsListNotEmpty() {
      return this.projectsList.length > 0;
    },

    paginationPage: {
      get() {
        return this.pagination.page;
      },
      set(val) {
        this.changePage(val);
      },
    },
  },

  created() {
    this.fetchProjects();
  },

  methods: {
    ...mapActions('hrProjects', [
      'fetchProjects',
      'changePage',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.hr-projects {
  &__empty {
    min-height: calc(100vh - 150px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__btn {
    color: white;
  }
}
</style>
